'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _class2, _temp;
// styled


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _LookUp = require('../LookUp');

var _LookUp2 = _interopRequireDefault(_LookUp);

var _Fieldset = require('../Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _RuleHint = require('../RuleHint');

var _RuleHint2 = _interopRequireDefault(_RuleHint);

var _rules = require('../Webform/rules');

var _rules2 = _interopRequireDefault(_rules);

var _Form = require('../Observables/Form');

var _Form2 = _interopRequireDefault(_Form);

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

var _validationMessage = require('../LookUp/styled/validation-message');

var _validationMessage2 = _interopRequireDefault(_validationMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Relation = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Relation, _Component);

  function Relation(props) {
    (0, _classCallCheck3.default)(this, Relation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Relation.__proto__ || (0, _getPrototypeOf2.default)(Relation)).call(this, props));

    _this.lookUpFields = {
      relation_number: {
        elementKey: 'relation_number',
        formKey: 'relation_number' + props.formKeySuffix,
        triggerLookUp: true,
        apiValue: function apiValue() {
          return false;
        },
        required: true
      },
      postcode: {
        elementKey: 'postcode',
        formKey: 'address_postcode' + (_this.fullAddressLookUp() ? '-' + _this.fullAddressLookUp() : props.formKeySuffix),
        triggerLookUp: true,
        apiValue: function apiValue() {
          return false;
        },
        required: true
      }
    };

    _this.lookUpBase = props.url + '/salesforce-lookup/contact?_format=json';

    var lookUpKey = _this.getLookUpKey(props);
    var field = props.formStore.getField(props.field['#webform_key']);

    _rules2.default.set('relation_membership_' + props.field['#webform_key'], {
      rule: function rule() {
        var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);
        return !field.element['#membership_validation'] || !lookUp || !lookUp.lookUpSent || lookUp.lookUpSent && lookUp.lookUpSuccessful;
      },
      hint: function hint() {
        return null;
      },
      shouldValidate: function shouldValidate() {
        return props.fields.reduce(function (shouldValidate, item) {
          return shouldValidate && !item.isEmpty && item.isBlurred && item.valid;
        }, true);
      }
    });

    props.registerLookUp(lookUpKey, _this.lookUpFields);
    return _this;
  }

  (0, _createClass3.default)(Relation, [{
    key: 'getLookUpKey',
    value: function getLookUpKey(props) {
      return (props || this.props).field['#webform_key'] + '-relation';
    }

    /**
     * If Relation field has full address element, get its webform key to add as suffix to fields.
     * @returns {bool|string} Returns false if not full address field (i.e. postcode only) or string of address webform key.
     */

  }, {
    key: 'fullAddressLookUp',
    value: function fullAddressLookUp() {
      var _this2 = this;

      return (0, _getNested2.default)(function () {
        return _this2.props.field.composite_elements.find(function (element) {
          return element['#type'] === 'webform_address_custom' || element['#type'] === 'dutch_address';
        })['#webform_key'];
      });
    }
  }, {
    key: 'prepareLookUp',
    value: function prepareLookUp(fields) {
      var _this3 = this;

      var performLookUp = this.props.fields.reduce(function (shouldValidate, item) {
        return shouldValidate && !item.isEmpty && item.isBlurred && item.valid;
      }, true);

      if (!performLookUp) {
        return false;
      }

      var query = '&relation=' + fields.relation_number + '&postal_code=' + fields.postcode;

      return {
        query: query,
        checkResponse: function checkResponse(json) {
          return json.Id && (!_this3.props.field['#membership_validation'] || parseInt(json.Aantal_lidmaatschappen__c, 10) > 0) || false;
        },
        isSuccessful: function isSuccessful(response) {
          return !!response;
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var field = this.props.formStore.getField(this.lookUpFields.relation_number.formKey);
      var lookUpKey = this.getLookUpKey();
      var lookUp = (0, _mobx.get)(field.lookUps, lookUpKey);

      return _react2.default.createElement(
        _Fieldset2.default,
        this.props,
        lookUp && lookUp.lookUpSent && !lookUp.lookUpSuccessful && _react2.default.createElement(_RuleHint2.default, { component: _react2.default.createElement(_validationMessage2.default, null), key: 'relation_' + lookUpKey, hint: _WebformUtils2.default.getCustomValue(this.props.field, 'relationError', this.props.settings) || _WebformUtils2.default.getErrorMessage(this.props.field, '#required_error') || 'We don\'t recognise this combination of relation number and postal code. Please check again, or proceed anyway.' })
      );
    }
  }]);
  return Relation;
}(_react.Component), _class2.meta = {
  labelVisibility: _Fieldset2.default.meta.labelVisibility,
  validations: [function (el) {
    return 'relation_membership_' + el.key;
  }],
  hasValue: false
}, _class2.propTypes = {
  field: _propTypes2.default.shape({
    '#webform_key': _propTypes2.default.string.isRequired,
    '#relationError': _propTypes2.default.string,
    '#membership_validation': _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
    composite_elements: _propTypes2.default.arrayOf(_propTypes2.default.shape())
  }).isRequired,
  fields: _propTypes2.default.arrayOf(_propTypes2.default.shape()).isRequired,
  onBlur: _propTypes2.default.func.isRequired,
  formKeySuffix: _propTypes2.default.string.isRequired,
  formStore: _propTypes2.default.instanceOf(_Form2.default).isRequired,
  url: _propTypes2.default.string.isRequired,
  settings: _propTypes2.default.shape().isRequired,
  registerLookUp: _propTypes2.default.func.isRequired
}, _temp)) || _class;

exports.default = (0, _LookUp2.default)(Relation);